import PayPal5 from './PayPal5'
export default PayPal5
